<div
  class="uploadfilecontainer"
  (click)="selectFile()"
  appDragDrop
  (fileDropped)="uploadFile($event)"
>
  <input
    hidden
    type="file"
    [attr.multiple]="selectMultiple ? 'multiple' : null"
    #fileInput
    (change)="uploadFile($any(fileInput.files))"
  />
  <h1 class="upload-info-text upload-info-primary">
    {{ infoText | translate }}
  </h1>

  <div class="upload-icon" aria-hidden="true"></div>

  <div class="upload-info-container">
    <h2 class="upload-info-text upload-info-secondary">
      {{ additionalInfo | translate }}
    </h2>
    <h2 *ngIf="fileNameInfo" class="upload-info-text upload-info-file-name">
      {{ fileNameInfo | translate }}
    </h2>
  </div>
</div>
